import React from 'react';
import { LiveCounter } from '../LiveCounter';
import { SourceRef } from '../SourceRef';
interface CounterPanelProps {
  kind: 'human' | 'machine';
  title: string;
  subtitle: string;
  base: number;
  baseTime: number;
  ratePerSec: number;
  sourceId: string;
  rateLabel: React.ReactNode;
  footnote: React.ReactNode;
}
export function CounterPanel({
  kind,
  title,
  subtitle,
  base,
  baseTime,
  ratePerSec,
  sourceId,
  rateLabel,
  footnote
}: CounterPanelProps) {
  const color = kind === 'human' ? 'text-human' : 'text-machine';
  return <div className="py-8 md:px-8 md:first:pl-0 md:last:pr-0" data-id="element-31" data-mp="2x06avv1d7mz1">
      <div className="flex items-baseline justify-between gap-4" data-id="element-32" data-mp="3b0pcokf8lwsr">
        <h2 className={`font-mono text-xs font-medium uppercase tracking-[0.18em] ${color}`} data-id="element-33" data-mp="361crs57xezst">
          {title}
          <SourceRef id={sourceId} data-id="element-34" data-mp="1gm690eiyln95" />
        </h2>
        <span className="font-mono text-[11px] text-muted" data-id="element-35" data-mp="1gmy4zqggxmzy">{subtitle}</span>
      </div>
      <p className={`mt-4 leading-none tracking-tight ${color} text-[clamp(2.1rem,4.9vw,4.5rem)]`} data-id="element-36" data-mp="1bomvxhxzzgis">
        <LiveCounter base={base} baseTime={baseTime} ratePerSec={ratePerSec} label={title} data-id="element-37" data-mp="o8mkrj4equnq" />
      </p>
      <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 font-mono text-[12px] text-muted" data-id="element-38" data-mp="t7673kmwy8gm">
        <span data-id="element-39" data-mp="y3wrgk5r3q7u">{rateLabel}</span>
        <span className="text-faint" aria-hidden="true" data-id="element-40" data-mp="y3n0at8yzd0k">
          ·
        </span>
        <span data-id="element-41" data-mp="12yaqcwjmgfh9">{footnote}</span>
      </div>
    </div>;
}